










































import { Component, Vue } from "vue-property-decorator";
import Confirm from "@/shared/components/confirm.vue";
import {
  ExtenderPlano,
  TipoPlano,
  ConsultoresService,
} from "@/services/consultores.service";
import Modal from "@/shared/components/modal.vue";
import { required } from "@/shared/validators";

interface ComboItem {
  text: string;
  value: TipoPlano;
}

@Component({
  components: {
    Modal,
    Confirm,
  },
})
export default class Manter extends Vue {
  extenderPlano: ExtenderPlano = {
    idConsultor: 0,
    tipoPlano: TipoPlano["BonusLite"],
    quantidadeDias: 1,
    observacao: "",
  };
  tipo: ComboItem | null = null;
  existeAssinatura = false;
  valid = false;
  loading = false;

  items = [
    { text: "Bônus Lite", value: TipoPlano["BonusLite"] },
    { text: "Bônus Essencial", value: TipoPlano["Bonus"] },
    { text: "Bônus Essencial Conectada", value: TipoPlano["BonusEssencialConectada"] },
    { text: "Bônus Super Conectada", value: TipoPlano["BonusSuperConectada"] },
    { text: "Bônus Hiper Conectada", value: TipoPlano["BonusHiperConectada"] },
  ];

  rules = {
    tipoPlano: [required()],
    quantidadeDias: [required()],
    observacao: [required()],
  };

  required = (v: any) => {
    return !!v || "Campo obrigatório";
  };

  get tituloManter(): string {
    return "Extender/Criar o plano";
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async novoPlano(idConsultor: number, existeAssinatura: boolean) {
    this.extenderPlano.tipoPlano = TipoPlano["BonusLite"];
    this.extenderPlano.quantidadeDias = 1;
    this.extenderPlano.observacao = "";
    this.existeAssinatura = existeAssinatura;
    this.extenderPlano.idConsultor = idConsultor;

    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    return p;
  }

  async salvarPlano() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      if (
        this.existeAssinatura &&
        this.extenderPlano.tipoPlano == TipoPlano["Bonus"]
      ) {
        if (!(await this.confirmar())) {
          return;
        }
      }
      if (this.extenderPlano) {
        this.loading = true;
        try {
          await ConsultoresService.ExtenderPlano(this.extenderPlano);
          this.loading = false;
        } catch {
          this.loading = false;
        }
      }
      return modal.close(true);
    }
  }

  async confirmar() {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Extender/Criar o plano`;
    const text = `Existe assinatura lite contratado/ativo e a bonificação para a assinatura Empresária Online pode ser excluída caso a cliente faça a migração para o mesmo.`;
    const res = await modalConfirm.open(title, text);
    return res;
  }
}
